import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getHeaders } from "./getHeaders";

export const getDiscount = createAsyncThunk(
  "Discount/getDiscount",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/discounts`, {
          headers: getHeaders(),

          params: data && data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getDiscountID = createAsyncThunk(
  "Discount/getDiscountID",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/discounts/${id}`, {
          headers: getHeaders(),
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const addDiscount = createAsyncThunk(
  "Discount/addDiscount",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/admin/discounts`, data, {
          headers: getHeaders(true),
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateDiscount = createAsyncThunk(
  "Discount/updateDiscount",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/discounts/${data.id}/update`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const delDiscount = createAsyncThunk(
  "Discount/delDiscount",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/discounts${
          !Array.isArray(id) ? `/${id}` : ""
        }`,
        {
          headers: getHeaders(),
          ...(Array.isArray(id) && { data: { ids: id } }), // إرسال `id` كمصفوفة داخل `data`
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const DiscountSlice = createSlice({
  name: "Discount",
  initialState: {
    isDiscountLoading: false,
    error: null,
    DiscountArr: null,
    DicountIDArr: null,
  },

  extraReducers: (builder) => {
    builder

      .addCase(getDiscount.pending, (state) => {
        state.isDiscountLoading = true;
      })
      .addCase(getDiscount.fulfilled, (state, action) => {
        state.isDiscountLoading = false;
        state.DiscountArr = action.payload.data;
      })
      .addCase(getDiscount.rejected, (state, action) => {
        state.isDiscountLoading = false;
      })

      .addCase(getDiscountID.pending, (state) => {
        state.isDiscountLoading = true;
      })
      .addCase(getDiscountID.fulfilled, (state, action) => {
        state.isDiscountLoading = false;
        state.DicountIDArr = action.payload.data;
      })
      .addCase(getDiscountID.rejected, (state, action) => {
        state.isDiscountLoading = false;
      })
      // addDiscount
      .addCase(addDiscount.pending, (state) => {
        state.isDiscountLoading = true;
      })
      .addCase(addDiscount.fulfilled, (state, action) => {
        state.isDiscountLoading = false;
      })
      .addCase(addDiscount.rejected, (state, action) => {
        state.isDiscountLoading = false;
      })
      // updateDiscount
      .addCase(updateDiscount.pending, (state) => {
        state.isDiscountLoading = true;
      })
      .addCase(updateDiscount.fulfilled, (state, action) => {
        state.isDiscountLoading = false;
      })
      .addCase(updateDiscount.rejected, (state, action) => {
        state.isDiscountLoading = false;
      })
      .addCase(delDiscount.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(delDiscount.fulfilled, (state, action) => {
        state.isProductLoading = false;

        const idsToDelete = Array.isArray(action.meta.arg)
          ? action.meta.arg
          : [action.meta.arg];

        state.DiscountArr = state.DiscountArr.filter(
          (ele) => !idsToDelete.includes(ele.id)
        );
      })
      .addCase(delDiscount.rejected, (state, action) => {
        state.isProductLoading = false;
      });
  },
});

export default DiscountSlice.reducer;
